import '../../style/base.css';
import '../../overlay/index.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/popup/style/index.js
// module id = 210
// module chunks = 7